<div class="flex h-screen overflow-hidden font-sans text-sm">

  <!-- ── Dark sidebar ─────────────────────────────────────────────── -->
  <aside class="flex w-56 flex-shrink-0 flex-col bg-zinc-900">

    <!-- Logo -->
    <div class="flex h-12 flex-shrink-0 items-center gap-2.5 border-b border-zinc-800 px-4">
      <div class="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-violet-600">
        <lucide-icon name="shield" [size]="14" color="white" [strokeWidth]="2.5"></lucide-icon>
      </div>
      <span class="text-sm font-semibold text-white">KernalHQ</span>
      <span class="ml-auto rounded bg-red-600 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-widest text-white">
        Admin
      </span>
    </div>

    <!-- Nav sections -->
    <nav class="flex-1 overflow-y-auto py-4 px-2">
      <div *ngFor="let section of navSections" class="mb-5">
        <p class="mb-1.5 px-3 text-[10px] font-semibold uppercase tracking-widest text-zinc-500">
          {{ section.label }}
        </p>
        <ul class="space-y-0.5">
          <li *ngFor="let item of section.items">
            <a
              [routerLink]="item.route"
              routerLinkActive="!bg-zinc-800 !text-white"
              [routerLinkActiveOptions]="{ exact: item.exact }"
              class="flex items-center gap-2.5 rounded-lg px-3 py-2 text-xs text-zinc-400 transition-colors hover:bg-zinc-800 hover:text-zinc-200"
            >
              <lucide-icon [name]="item.icon" [size]="14" [strokeWidth]="1.75" class="flex-shrink-0"></lucide-icon>
              {{ item.label }}
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <!-- Footer -->
    <div class="flex-shrink-0 border-t border-zinc-800 p-3">
      <div class="flex items-center gap-2.5 rounded-lg px-2 py-2">
        <div class="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-red-900/60 text-[10px] font-bold text-red-400">
          {{ userInitials$ | async }}
        </div>
        <div class="min-w-0 flex-1">
          <p class="truncate text-xs font-medium text-zinc-300">{{ displayName$ | async }}</p>
          <p class="truncate text-[10px] text-zinc-600">Admins group</p>
        </div>
        <button (click)="signOut()" class="text-zinc-600 transition-colors hover:text-zinc-400" title="Sign out">
          <lucide-icon name="log-out" [size]="14" [strokeWidth]="1.75"></lucide-icon>
        </button>
      </div>
    </div>

  </aside>

  <!-- ── Main area ─────────────────────────────────────────────────── -->
  <div class="flex min-w-0 flex-1 flex-col overflow-hidden bg-zinc-50">

    <!-- Top command bar -->
    <header class="flex h-12 flex-shrink-0 items-center justify-between border-b border-zinc-200 bg-white px-5">

      <!-- Breadcrumb -->
      <div class="flex items-center gap-1.5 text-xs">
        <span class="text-zinc-400">Admin</span>
        <lucide-icon name="chevron-right" [size]="12" class="text-zinc-300" [strokeWidth]="1.5"></lucide-icon>
        <span class="font-medium text-zinc-900">{{ pageTitle }}</span>
      </div>

      <!-- Health + avatar -->
      <div class="flex items-center gap-3">
        <div class="flex items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1">
          <span class="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
          <span class="text-[11px] font-medium text-emerald-700">Operational</span>
        </div>
        <div class="flex h-7 w-7 items-center justify-center rounded-full bg-red-100 text-[10px] font-bold text-red-700">
          {{ userInitials$ | async }}
        </div>
      </div>

    </header>

    <!-- Page content -->
    <main class="flex-1 overflow-y-auto">
      <router-outlet></router-outlet>
    </main>

  </div>
</div>
